const mytripsLeg = require('./mytrips_leg');
const confirmationLeg = require('./confirmation_leg');


function legFactory(legData) {
    return isMyTripsDto(legData) ? mytripsLeg(legData) : confirmationLeg(legData);
}

function isMyTripsDto(dto) {
    return {}.hasOwnProperty.call(dto, 'section');
}

module.exports = legFactory;
